module.exports = __webpack_public_path__ + "img/inspiration-3.4896437.jpg";